export const QUOTE_LINE_ITEM_TYPES = {
  ACCOUNT_MODIFICATION: 'ACCOUNT_MODIFICATION',
  CREATE_ENTITLEMENT: 'CREATE_ENTITLEMENT',
  AMEND_ENTITLEMENT: 'AMEND_ENTITLEMENT',
  REACTIVATE_ENTITLEMENT: 'REACTIVATE_ENTITLEMENT',
  CANCEL_ENTITLEMENT: 'CANCEL_ENTITLEMENT',
};
